module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/042-aruba-bd274777da199c499bb0bf5a6eb4a79c.svg";